import { observer } from 'mobx-react-lite';
import styles from './style.module.css';
import { forwardRef, useEffect, useMemo } from 'react';
import m from 'skin/store/mb'
import Button from '../button';
import Icon from '../icon';

const Modal = forwardRef(({ onClose, children, showClose }, ref) => {
	const mb = m.isMobile;
	const dlg = useMemo(() => [styles.dialog, styles[mb ? 'mb' : 'pc']].join(' '), [mb]);
	const cont = useMemo(() => [styles.container, styles[mb ? 'mb' : 'pc']].join(' '), [mb]);
	useEffect(() => {
		const cur = ref.current;
		if (!cur) return;
		cur.showModal();
	}, []);
	return <dialog className={dlg} ref={ref} onClose={onClose}>
		<div className={cont}>
			{
				showClose && <Button className={styles.close} type='iconic' onClick={onClose}>
					<Icon name='cross' size='36%' />
				</Button>
			}
			{
				children || <>
					<Header>
						<span style={{ textAlign: 'center', alignSelf: 'center' }}>Здесь ничего нет</span>
					</Header>
					<Footer>
						<Button type='base-reverse' onClick={onClose}>Закрыть</Button>
					</Footer>
				</>
			}
		</div>
	</dialog>
})

export default observer(Modal);

export function Header({ children }) {
	if (!children) return null;
	return <div className={styles.top}>{children}</div>;
}

export function Content({ children }) {
	return <div className={styles.box}>
		<div className={styles.content}>
			{children}
		</div>
	</div>
}

export function Footer({ children }) {
	if (!children) return null;
	return <div className={styles.bottom}>{children}</div>;
}